import { Injectable } from '@angular/core';
import { FetchPolicy } from '@apollo/client/core';
import { Apollo, QueryRef } from 'apollo-angular';
import { EmptyObject } from 'apollo-angular/types';
import { DocumentNode } from 'graphql';
import { Observable } from 'rxjs';

@Injectable()
export class ApolloService {
  constructor(public apollo: Apollo) {}

  public mutate(query: DocumentNode, variables: any, refetchQuery?: QueryRef<any, EmptyObject>): void {
    this.apollo
      .mutate({
        mutation: query,
        variables
      })
      .subscribe(() => {
        if (refetchQuery) {
          refetchQuery.refetch();
        }
      });
  }

  public mutateAndExecute(query: DocumentNode, variables: any, callback: (arg: any) => void ): void{
    this.apollo
    .mutate({
      mutation: query,
      variables
    })
    .subscribe( ( result ) => {
      if (callback) {
        callback( result );
      }
    });
  }

  /**
   * `options` ist optional und aendert das Bestandsverhalten nicht: ohne Angabe gilt weiterhin
   * Apollos Default-fetchPolicy fuer query ('cache-first'). Nur die globale watchQuery-Policy ist in
   * graphql.module.ts auf 'network-only' gesetzt, `query` faellt nicht darunter.
   *
   * Diagnose-Flaechen (#737) muessen 'network-only' setzen: nach einem Requeue zeigt der Cache sonst
   * weiter FAILED, obwohl die Zeilen serverseitig schon auf PENDING stehen.
   */
  public query<T>(query: DocumentNode, variables?: any, options?: { fetchPolicy?: FetchPolicy }): Observable<any> {
    return this.apollo.query<T>({
      query,
      variables,
      ...options
    });
  }

  public mutateObservable<T>(query: DocumentNode, variables?: any): Observable<any> {
    return this.apollo.mutate<T>({
      mutation: query,
      variables
    });
  }

}
